// extracted by mini-css-extract-plugin
export var divider = "_sw-0";
export var systemMessage = "_sw-1";